import { render, staticRenderFns } from "./AuctionImage.vue?vue&type=template&id=6e61e21e&scoped=true"
import script from "./AuctionImage.vue?vue&type=script&lang=js"
export * from "./AuctionImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e61e21e",
  null
  
)

export default component.exports